
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { Build } from '@/types/build';
import moment from 'moment';

@Component
export default class BuildMainSiteTimeLine extends Vue {
  @Getter('builds/showMainSitePanel') showMainSitePanel!: number | null;
  @Mutation('builds/updateShowMainPanel') updateShowMainPanel!: Function;
  @Prop() build!: Build;

  get createdAt(): string {
    moment.locale('en-gb');
    return moment(this.build.created_at as string).fromNow();
  }

  get progressValue(): string {
    return (
        (this.build.current_count / this.build.total_count) * 100)
        .toLocaleString('en-GB', {maximumFractionDigits: 0})
  }

  get showPanel(): number | null {
    return this.showMainSitePanel;
  }
  set showPanel(value) {
    this.updateShowMainPanel(value);
  }
}
